import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-started-by',
  templateUrl: './started-by.component.html',
  styleUrls: ['./started-by.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class StartedByComponent implements OnInit {
  columnsToDisplay = ['Name', 'Description', 'IsActive'];
  headercolumnsToDisplay = ['Started By', 'Description', 'Is Active'];
  public show: boolean = false;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }


  startedform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.startedform = this.formBuilder.group({

      name: ['',],
      isactive: ['',],
      description: ['',],
      names: ['',],
      isactivee: ['',],
      descriptionn: ['',]

    });

  }

  get f() { return this.startedform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.startedform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.startedform.value))
  }
}

